import React from 'react'
import { Button, Dropdown, Form, Input } from 'semantic-ui-react'
import { useCrmLookups } from 'hooks/crm'
import { Card } from './ui'

const STATIC_STAGES = ['Won', 'Customer', 'No deal']

/**
 * Filter panel for the Contacts list. Every change goes back to page 1 (handled by the parent).
 * @param {{ query: import('utility/crm/types').CrmContactsQuery, onChange: (patch: Partial<import('utility/crm/types').CrmContactsQuery>) => void, onClear: () => void }} props
 */
export const ContactFilters = ({ query, onChange, onClear }) => {
    const { lookups } = useCrmLookups()
    const opt = list => (list || []).map(v => ({ key: v, value: v, text: v }))
    const stageNames = [...(lookups?.Stages || []).map(s => s.Name), ...STATIC_STAGES]
    const stageOptions = Array.from(new Set(stageNames)).map(v => ({ key: v, value: v, text: v }))
    const ownerOptions = (lookups?.Users || []).map(u => ({ key: u.UserId, value: u.UserId, text: u.FullName }))
    const set = (key, value) => onChange({ [key]: value === '' || value === null ? undefined : value })

    return (
        <Card aria-label="Contact filters" style={{ marginBottom: 12 }}>
            <Form>
                <Form.Group widths="equal">
                    <Form.Field>
                        <label htmlFor="crm-filter-type">Type</label>
                        <Dropdown
                            id="crm-filter-type"
                            selection
                            clearable
                            placeholder="Any type"
                            options={opt(lookups?.AccountTypes)}
                            value={query.Type || ''}
                            onChange={(_, d) => set('Type', d.value)}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label htmlFor="crm-filter-owner">Owner</label>
                        <Dropdown
                            id="crm-filter-owner"
                            selection
                            clearable
                            search
                            placeholder="Any owner"
                            options={ownerOptions}
                            value={query.OwnerUserId ?? ''}
                            onChange={(_, d) => set('OwnerUserId', d.value)}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label htmlFor="crm-filter-stage">Stage</label>
                        <Dropdown
                            id="crm-filter-stage"
                            selection
                            clearable
                            placeholder="Any stage"
                            options={stageOptions}
                            value={query.Stage || ''}
                            onChange={(_, d) => set('Stage', d.value)}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label htmlFor="crm-filter-industry">Industry</label>
                        <Dropdown
                            id="crm-filter-industry"
                            selection
                            clearable
                            search
                            placeholder="Any industry"
                            options={opt(lookups?.Industries)}
                            value={query.Industry || ''}
                            onChange={(_, d) => set('Industry', d.value)}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label htmlFor="crm-filter-tag">Tag</label>
                        <Input
                            id="crm-filter-tag"
                            placeholder="Exact tag"
                            value={query.Tag || ''}
                            onChange={(_, d) => set('Tag', d.value.trim() === '' ? '' : d.value)}
                        />
                    </Form.Field>
                </Form.Group>
                <Button type="button" size="small" onClick={onClear}>
                    Clear filters
                </Button>
            </Form>
        </Card>
    )
}
